<template>
  <div id="progreso">
    <section class="pantalla">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="logo abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div class="cont-btn-sig btn-avanzar col-12">
              <button @click="avanzar" class="btn-sig">
                <span class="texto">
                  <span class="bold">CONTINUAR</span>
                </span>
                <img
                  class="icono"
                  src="../../assets/imgs/mision/cohete.png"
                  alt="icono"
                />
                <span class="flecha">
                  <img
                    src="../../assets/imgs/mision/flecha-sig3.png"
                    alt="icono"
                  />
                </span>
              </button>
              <div class="flecha2">
                <img
                  src="../../assets/imgs/mision/flecha-sig2.png"
                  alt="icono"
                />
              </div>
              <div class="flecha1">
                <img
                  src="../../assets/imgs/mision/flecha-sig1.png"
                  alt="icono"
                />
              </div>
            </div>

            <div class="info abs" data-aos="zoom-in" data-aos-delay="400">
              <img
                src="../../assets/imgs/resultados/canales.png"
                alt="Encauce"
                class="img-fluid w-100"
              />
            </div>

            <div
              class="personaje abs"
              data-aos="fade"
              data-aos-delay="800"
              v-if="settings.personaje != null"
            >
              <img
                :src="
                  require('../../assets/imgs/resultados/' +
                    settings.personaje +
                    '-final.png')
                "
                alt="Encauce"
                class="img-fluid"
              />
              <img
                src="../../assets/imgs/progreso/brillo-amarillo.png"
                alt="Encauce"
                class="img-fluid brillo"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";
import router from "../../router/index";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      maya_outfit: -1,
      condicion: false,
      settings: {
        personaje: null,
        mision: 1,
      },
      avance: [],
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.getAvance();
  },
  methods: {
    async getAvance() {
      this.avance = await this.$store.dispatch("getAvance");
      console.log(this.avance);

      this.avatar = this.avance.avatar;
      if (this.avatar != null) {
        this.settings.personaje =
          this.avatar.slug_personaje + "-" + this.avatar.id_outfit;
      }
    },
    selecciona(mision) {
      router.push("/mision-" + mision + "-intro");
    },
    avanzar() {
      this.$router.push("/resultados/descarga");
    },
  },
};
</script>

<style lang="scss" scoped>
$amarillo: #ffcc00;
#progreso {
  background: url(../../assets/imgs/resultados/bg-resultados.jpg) no-repeat;
  background-size: cover;
  background-position: bottom right;
  .contentabs {
    .logo {
      bottom: 5%;
      left: 5%;
      width: 20%;
      position: absolute;
    }
    .centradoxy {
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      width: 80%;
      left: 50%;
    }
    .personaje {
      bottom: 4%;
      right: 8%;
      width: 20%;
      position: absolute;
      .brillo {
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.5;
        animation: titilar 2s infinite;
      }
    }

    .info {
      height: 70%;
      top: 5%;
      left: 3%;
      img {
        height: 100%;
        width: auto !important;
      }
    }

    .botonera {
      width: 40%;
      top: 13%;
      left: 54%;
      .bgtitulo {
        width: 80%;
        margin: 0 10%;
        position: relative;
        .texto {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          left: 0px;
        }
      }
      .mision {
        width: 33.33%;
        position: relative;
        .planeta {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
        .planeta-lock {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
      }
    }

    .btn-avanzar {
      position: absolute;
      bottom: 2%;
      left: 35%;
    }

    @media (min-width: 993px) {
      .personaje {
        bottom: 4%;
        right: 5%;
        width: 17%;
      }
    }
  }
}
</style>
